import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export enum LinkAuthMethodErrorTypeEnum {
    UNKNOWN_ERROR = 0,
    AUTH_METHOD_ALREADY_LINKED = 1,
    FAILED_TO_LINK = 2
}

export type FinishAccountLinkingRewardResponseParams = {
    isSuccess: boolean
    linkingError?: LinkAuthMethodErrorTypeEnum
};


export class FinishAccountLinkingReward extends JsToClientCommand<FinishAccountLinkingRewardResponseParams> {
    constructor(params: FinishAccountLinkingRewardResponseParams) {
        super(ClientCommands.FINISH_ACCOUNT_LINKING_REWARD, params);
    }
}
